enum FormFields {
  Password = 'password',
  NewPassword = 'newPassword',
  ConfirmPassword = 'confirmPassword',
}

const FormFieldsList = [
  FormFields.Password,
  FormFields.NewPassword,
  FormFields.ConfirmPassword,
];

export { FormFields, FormFieldsList };
